import {Anchor, createTopAnchor} from '@cypro/ui/components/ui/infinite-data-table'
import {queries} from '@/shared/integrations/zero'
import {ListActiveSubstancesInput} from '@cypro/engine/queries'
import {DrugCatalogItem} from '@cypro/engine/schema'
import {useQuery} from '@rocicorp/zero/react'
import {useEffect, useMemo, useState} from 'react'

export function useGetActiveSubstanceDrugs({
  sort = {dir: 'asc', field: 'name'},
  filters,
  limit,
}: Omit<Partial<ListActiveSubstancesInput>, 'cursor'> = {}) {
  const [anchor, setAnchor] = useState<Anchor<DrugCatalogItem>>(createTopAnchor<DrugCatalogItem>())

  const cursor =
    anchor.startRow?.id && anchor.startRow?.createdAt
      ? {
          id: anchor.startRow.id,
          direction: anchor.direction,
          createdAt: anchor.startRow.createdAt,
          name: anchor.startRow.name,
        }
      : undefined

  const query = queries.drugCatalog.listActiveSubstances({
    cursor,
    sort,
    filters: {status: ['active'] as const, ...filters},
    limit,
  })
  const [substances, meta] = useQuery(query)

  const filtersHash = useMemo(() => JSON.stringify(filters), [filters])
  useEffect(() => {
    setAnchor(createTopAnchor<DrugCatalogItem>())
  }, [sort?.dir, sort?.field, filtersHash, limit])

  return {
    query,
    meta,
    substances,
    anchor,
    fetchMore: setAnchor,
    canFetchMore: substances.length === limit,
    isFetching: meta.type === 'unknown',
  }
}
